import { render, staticRenderFns } from "./activityEditSemester.html?vue&type=template&id=5b52d1de&scoped=true&external"
import script from "./activityEditSemester.vue?vue&type=script&lang=js"
export * from "./activityEditSemester.vue?vue&type=script&lang=js"
import style0 from "./activityEditSemester.css?vue&type=style&index=0&id=5b52d1de&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b52d1de",
  null
  
)

export default component.exports